module.exports = __webpack_public_path__ + "static/services-1-a1168550490a50294e03846a61272971.jpg";